import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ScrollToTop from './helper/ScrollToTop';
import { GlobalStyle } from "./components/common/styles/global";

import Home from './Home';

import Librarian from './pages/Librarian/Librarian';

import Rules from './pages/Information/Rules';
import Committee from './pages/Information/Committee';
import Press from './pages/Information/Press';

import Membership from './pages/Services/Membership';
import Circulation from './pages/Services/Circulation';
import BookBank from './pages/Services/BookBank';
import ReferenceSection from './pages/Services/ReferenceSection';
import PeriodicalsSection from './pages/Services/PeriodicalsSection';
import ReadingRoom from './pages/Services/ReadingRoom';
import DepartmentLibraries from './pages/Services/DepartmentLibraries';
import UserAwareness from './pages/Services/UserAwareness';
import EmailAlert from './pages/Services/EmailAlert';
import Activities from './pages/Services/Activities';

import ItInfrastructure from './pages/Digital/ItInfrastructure';
import EResources from './pages/Digital/EResources';
import OpenAccessResources from './pages/Digital/OpenAccessResources';
import InstitutionMembership from './pages/Digital/InstitutionMembership';
import Plagiarism from './pages/Digital/Plagiarism';
import VideoSurveillance from './pages/Digital/VideoSurveillance';
import Nptl from './pages/Digital/Nptl';
import Ndl from './pages/Digital/Ndl';
import Mapmy from './pages/Digital/Mapmy';

import Gallery from './pages/Gallery/Gallery';

export default function App() {
    return (
        <Router>
            <GlobalStyle />
            <ScrollToTop />
            <Switch>
                <Route exact path={`${process.env.PUBLIC_URL + "/"}`} component={Home} />

                <Route exact path={`${process.env.PUBLIC_URL + "/library-librarian"}`} component={Librarian} />

                <Route exact path={`${process.env.PUBLIC_URL + "/library-rules"}`} component={Rules} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-committee"}`} component={Committee} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-press"}`} component={Press} />

                <Route exact path={`${process.env.PUBLIC_URL + "/library-membership"}`} component={Membership} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-circulation"}`} component={Circulation} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-bookbank"}`} component={BookBank} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-referencesection"}`} component={ReferenceSection} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-periodicalssection"}`} component={PeriodicalsSection} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-readingroom"}`} component={ReadingRoom} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-departmentlibraries"}`} component={DepartmentLibraries} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-userawareness"}`} component={UserAwareness} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-emailalert"}`} component={EmailAlert} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-activities"}`} component={Activities} />

                <Route exact path={`${process.env.PUBLIC_URL + "/library-itinfrastructure"}`} component={ItInfrastructure} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-eresources"}`} component={EResources} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-openaccessresources"}`} component={OpenAccessResources} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-institutionmembership"}`} component={InstitutionMembership} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-plagiarism"}`} component={Plagiarism} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-videosurveillance"}`} component={VideoSurveillance} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-nptl"}`} component={Nptl} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-ndl"}`} component={Ndl} />
                <Route exact path={`${process.env.PUBLIC_URL + "/library-mapmy"}`} component={Mapmy} />

                <Route exact path={`${process.env.PUBLIC_URL + "/library-gallery"}`} component={Gallery} />
            </Switch>
        </Router>
    )
}